import * as React from "react";
import './FormStepper.css'

import Step from "./Step/Step";
import {InputTypes} from "./InputTypes";
import {observer} from "mobx-react";
import {action} from "mobx";
import FormUtils from "../../FormUtils";

export interface IStep {
    isHeader?: boolean;
    selectedOption?: number
    inputPlaceHolder?: string;
    subTitle?: string;
    allowSkip?: boolean;
    isOptional?: boolean
    inputType: InputTypes;
    title: string;
    propName: string;
    isLocked?: boolean;
    customValidationCheck?: (inputValue: string) => boolean;
    postFinishCB?: (inputValue: string) => Promise<any>;
}

interface IProps {
    steps: IStep[];
    navigationProperty: string;
    store?: any;
    updateParentFormStatus?: (isFormFinished: boolean) => void;
}

interface ILocalState {
    finishedStepsControllers: boolean[];
}

@observer
export default class FormStepper  extends React.Component<
    IProps,
    ILocalState
    > {

    public nonActionSteps = ["paymentForm", "plaidConnection"];

    public state: ILocalState = {
        finishedStepsControllers: []
    }

    constructor(props: IProps){
        super(props);
        this.initiateStepsControllerAndStoreFormInput();
    }

    public componentWillReceiveProps = () => {
        this.setState(this.state);
    };

    public checkFormStatus = () => {
        const {updateParentFormStatus} = this.props;
        let result = true;
        this.state.finishedStepsControllers.forEach((val) => {
            result = val && result;
        })
        if(updateParentFormStatus) {
            updateParentFormStatus(result)
        }
        return result;
    };

    @action.bound
    public updateStepsController = (index: number, value: boolean) => {
        const {navigationProperty, store} = this.props;
        const newState = this.state;
        const tempArr = newState.finishedStepsControllers.slice();
        tempArr[index] = value;
        newState.finishedStepsControllers = tempArr;
        this.setState(newState, () => {
            if(navigationProperty) {
                this.checkFormStatus()? store.navigationController[navigationProperty] = true: store.navigationController[navigationProperty] = false;
            }
        });
    };

    public getPreviousStepStatus = (index: number) => {
        const {steps} = this.props;
        if(index === 0 || index === 1) {
            return true;
        }else {
            if (steps[index - 1].inputType === InputTypes.boolean) {
                return steps[index - 1].selectedOption !== undefined;
            }else {
                if(steps[index - 1].inputType === InputTypes.nested) {
                    return true;
                }
                if(steps[index].isLocked) {
                    return true;
                }
                return this.state.finishedStepsControllers[index - 2];
            }
        }
    };

    public renderSteps = () => {
        const {steps, store, navigationProperty} = this.props;
        return steps.map((step: any, index: number)=> {
            if(step === undefined) {
                return null;
            }
            const stepIndex = step.isHeader? -1 : index;
            const previousStepFinished = this.getPreviousStepStatus(index);
            const isLast =  index === steps.length - 1;
            const isFirst = index === 1;
            const selectInputOptions = step.options;
            const selectedOption = step.selectedOption;
            const cb = step.cb? step.cb : null;
            return <Step key={index}
                         isHeader={step.isHeader}
                         title={step.title}
                         specialTitleStyle={step.specialTitleStyle}
                         subTitle={step.subTitle}
                         secondSubTitle={step.secondSubTitle}
                         inputType={step.inputType}
                         inputPlaceHolder={step.inputPlaceHolder}
                         allowSkip={step.allowSkip}
                         propertyName={step.propName}
                         isPreviousStepFinished={previousStepFinished}
                         stepIndex={stepIndex}
                         isLast={isLast}
                         isFirst={isFirst}
                         updateNextStep={this.updateStepsController}
                         selectInputOptions={selectInputOptions}
                         selectedOption={selectedOption}
                         store={store}
                         errorLabel={step.errorLabel}
                         customValidationCheck={step.customValidationCheck}
                         formPageName={navigationProperty}
                         cb={cb}
                         isFormFinished={step.isHeader && this.checkFormStatus()}
                         dropdownOptions = {step.options}
                         shortInput={step.shortInput}
                         titleExplanationText = {step.description}
                         isLocked={step.isLocked}
                         postFinishCB={step.postFinishCB}
                         maxChars={step.maxChars}
            />
        });
    };

    public render() {
        return (<div className="form-steps-container" style={{height: "auto"}}>{this.renderSteps()}</div>)
    }

    private initiateStepsControllerAndStoreFormInput = () => {
        const {steps, store, navigationProperty} = this.props;
        const initialStepsController:boolean[] = [];
        if(!store.formInput[navigationProperty]) {
            store.formInput[navigationProperty] = {};
        }
        steps.forEach((step)=> {
            if(!step.isHeader && !step.isOptional) {
                const isStepFinishedValue: boolean = this.isStepFinished(step);
                initialStepsController.push(isStepFinishedValue);
                if(store.formInput[navigationProperty][step.propName] === undefined) {
                    store.formInput[navigationProperty][step.propName] = '';
                }
            }
        });
        const newState = this.state;
        newState.finishedStepsControllers = initialStepsController;
        this.setState(newState);
    }

    private isStepFinished = (step: any) => {
        const {store, navigationProperty} = this.props;
        if(!store.formInput[navigationProperty]) {
            return false;
        }
        return Boolean(store.formInput[navigationProperty][step.propName] !== undefined &&
            FormUtils.validateInput(step.inputType, store.formInput[navigationProperty][step.propName], step.customValidationCheck));
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/components/FormStepper/FormStepper.tsx